const _temp0 = require("url:./alien_attack_1.webm");
const _temp1 = require("url:./alien_attack_2.webm");
const _temp2 = require("url:./alien_attack_3.webm");
const _temp3 = require("url:./alien_attack_4.webm");
const _temp4 = require("url:./alien_death_1.webm");
const _temp5 = require("url:./alien_death_2.webm");
const _temp6 = require("url:./alien_death_3.webm");
const _temp7 = require("url:./alien_move_1.webm");
const _temp8 = require("url:./alien_move_2.webm");
const _temp9 = require("url:./alien_move_3.webm");
const _temp10 = require("url:./alien_move_4.webm");
const _temp11 = require("url:./building_built.webm");
const _temp12 = require("url:./building_destroyed.webm");
const _temp13 = require("url:./buzz.webm");
const _temp14 = require("url:./colonist_move_1.webm");
const _temp15 = require("url:./colonist_move_2.webm");
const _temp16 = require("url:./colonist_move_3.webm");
const _temp17 = require("url:./colonist_move_4.webm");
const _temp18 = require("url:./day_intro.webm");
const _temp19 = require("url:./day_loop.webm");
const _temp20 = require("url:./explosion_1.webm");
const _temp21 = require("url:./explosion_2.webm");
const _temp22 = require("url:./explosion_3.webm");
const _temp23 = require("url:./explosion_4.webm");
const _temp24 = require("url:./explosion_5.webm");
const _temp25 = require("url:./explosion_6.webm");
const _temp26 = require("url:./explosion_7.webm");
const _temp27 = require("url:./factory.webm");
const _temp28 = require("url:./factory_1.webm");
const _temp29 = require("url:./factory_2.webm");
const _temp30 = require("url:./farm.webm");
const _temp31 = require("url:./laser_activate.webm");
const _temp32 = require("url:./laser_active.webm");
const _temp33 = require("url:./laser_cancel.webm");
const _temp34 = require("url:./laser_shot_1.webm");
const _temp35 = require("url:./laser_shot_2.webm");
const _temp36 = require("url:./laser_shot_3.webm");
const _temp37 = require("url:./laser_shot_4.webm");
const _temp38 = require("url:./laser_shot_5.webm");
const _temp39 = require("url:./laser_shot_6.webm");
const _temp40 = require("url:./mine_1.webm");
const _temp41 = require("url:./mine_2.webm");
const _temp42 = require("url:./night_intro.webm");
const _temp43 = require("url:./night_loop.webm");
const _temp44 = require("url:./pickaxe_loop.webm");
const _temp45 = require("url:./player_move_1.webm");
const _temp46 = require("url:./player_move_2.webm");
const _temp47 = require("url:./player_move_3.webm");
const _temp48 = require("url:./player_move_4.webm");
const _temp49 = require("url:./power_off.webm");
const _temp50 = require("url:./power_on.webm");
const _temp51 = require("url:./ui_alert.webm");
const _temp52 = require("url:./ui_chime.webm");
const _temp53 = require("url:./ui_successful_valid.webm");
const _temp54 = require("url:./ui_unsuccessful_invalid.webm");
module.exports = {
  "alien_attack_1": _temp0,
  "alien_attack_2": _temp1,
  "alien_attack_3": _temp2,
  "alien_attack_4": _temp3,
  "alien_death_1": _temp4,
  "alien_death_2": _temp5,
  "alien_death_3": _temp6,
  "alien_move_1": _temp7,
  "alien_move_2": _temp8,
  "alien_move_3": _temp9,
  "alien_move_4": _temp10,
  "building_built": _temp11,
  "building_destroyed": _temp12,
  "buzz": _temp13,
  "colonist_move_1": _temp14,
  "colonist_move_2": _temp15,
  "colonist_move_3": _temp16,
  "colonist_move_4": _temp17,
  "day_intro": _temp18,
  "day_loop": _temp19,
  "explosion_1": _temp20,
  "explosion_2": _temp21,
  "explosion_3": _temp22,
  "explosion_4": _temp23,
  "explosion_5": _temp24,
  "explosion_6": _temp25,
  "explosion_7": _temp26,
  "factory": _temp27,
  "factory_1": _temp28,
  "factory_2": _temp29,
  "farm": _temp30,
  "laser_activate": _temp31,
  "laser_active": _temp32,
  "laser_cancel": _temp33,
  "laser_shot_1": _temp34,
  "laser_shot_2": _temp35,
  "laser_shot_3": _temp36,
  "laser_shot_4": _temp37,
  "laser_shot_5": _temp38,
  "laser_shot_6": _temp39,
  "mine_1": _temp40,
  "mine_2": _temp41,
  "night_intro": _temp42,
  "night_loop": _temp43,
  "pickaxe_loop": _temp44,
  "player_move_1": _temp45,
  "player_move_2": _temp46,
  "player_move_3": _temp47,
  "player_move_4": _temp48,
  "power_off": _temp49,
  "power_on": _temp50,
  "ui_alert": _temp51,
  "ui_chime": _temp52,
  "ui_successful_valid": _temp53,
  "ui_unsuccessful_invalid": _temp54
}